const wordsToReplace = {
    "mhd": "Mohammad",
    "ALX": "Alex",
    "dany": "Danial",
    "mo": "Mohammad"
};

export default wordsToReplace;
